// extracted by mini-css-extract-plugin
module.exports = {"inputs":"inputs___22SFQ","day":"day___2p20T","month":"month___GLE9R","year":"year___1uXmE","fullDate":"fullDate___1Mt1Z"};